import { ValueChartConfig } from "src/app/features/prob/models";
import { RequestBaseIds, RequestBaseSet, RequestDeleteIds, ResponseBaseSet } from "src/app/modules/fwcore/models";


export class RequestValueChartConfig extends RequestBaseIds<string> {

  /**
 * Gets or sets the model value identifier source for whom we wish to return.
 */
  modelValueId?: string | null;

  /**
* Gets or sets the category identifier filter.
*/
  categoryId?: string | null;

}

export class ResponseValueChartConfig extends ResponseBaseSet<ValueChartConfig> {
}


export class RequestValueChartConfigSet extends RequestBaseSet<ValueChartConfig> {
}

export class ResponseValueChartConfigSet extends ResponseBaseSet<ValueChartConfig> {
}

export class RequestValueChartConfigDelete extends RequestDeleteIds {

  /**
   * Gets or sets the model value identifier source for whom we wish to delete any chart configs for.
   */
  modelValueId?: string | null;
}
